/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by mj codegen manifest
 * App: mj_explorer
 * Dependency tree: 2 packages contain @RegisterClass
 *
 * This file imports every @RegisterClass decorated class by name and places
 * them in an exported array, creating a static code path that prevents
 * tree-shaking from removing them.
 */

/* eslint-disable @typescript-eslint/no-unused-vars */

// mj_generatedentities (39 classes)
import {
    APIKeyEntityExtended,
    BaseMessageConverter,
    BettyBotLLMConverter,
    ChannelEntityExtended,
    ChannelMessageEntityExtendedClient,
    IzzyAssignmentRuleEntity,
    IzzyAutomationRuleEntity,
    IzzyChannelActionEntity,
    IzzyChannelExtensionEntity,
    IzzyChannelMessageAttachmentEntity,
    IzzyChannelMessageEntity,
    IzzyChannelMessageNoteEntity,
    IzzyChannelTypeActionEntity,
    IzzyChannelTypeExtensionEntity,
    IzzyCredentialExtensionEntity,
    IzzyCredentialTypeExtensionEntity,
    IzzyIssueTicketNumberEntity,
    IzzyIzzyActionCategoryEntity,
    IzzyIzzyActionEntity,
    IzzyIzzyActionOrganizationEntity,
    IzzyMacroEntity,
    IzzyOrganizationActionEntity,
    IzzyPendingCrawlResultEntity,
    IzzyPersonSkillEntity,
    IzzySLAPolicyEntity,
    IzzyScopeEntity,
    IzzySettingExtensionEntity,
    IzzySkillEntity,
    IzzySkillIssueTypeEntity,
    IzzyTicketMergeEntity,
    IzzyTicketNumberSequenceEntity,
    IzzyTicketSLAStateEntity,
    IzzyTicketSuggestionEntity,
    IzzyTicketTeamEntity,
    IzzyTicketTeamMemberEntity,
    OpenAILLMConverter,
    OrganizationActionEntityExtendedClient,
    OrganizationEntityExtended,
    OrganizationSettingEntityExtended,
} from 'mj_generatedentities';

// izzy-ui (6 classes)
import {
    IzzyAdministrationResource,
    IzzyAnalyticsResource,
    IzzyApplication,
    IzzyMessageApprovalResource,
    IzzyMessagesContainerResource,
    IzzyTicketWorkspaceResource,
} from 'izzy-ui';

/**
 * Runtime references to every @RegisterClass decorated class.
 * This array creates a static code path the bundler cannot tree-shake.
 *
 * Split into fixed-size chunks so no single array literal grows a union large
 * enough to trip TS2590; the exported array is their concatenation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CLASS_REGISTRATIONS_0: any[] = [
    APIKeyEntityExtended,
    BaseMessageConverter,
    BettyBotLLMConverter,
    ChannelEntityExtended,
    ChannelMessageEntityExtendedClient,
    IzzyAssignmentRuleEntity,
    IzzyAutomationRuleEntity,
    IzzyChannelActionEntity,
    IzzyChannelExtensionEntity,
    IzzyChannelMessageAttachmentEntity,
    IzzyChannelMessageEntity,
    IzzyChannelMessageNoteEntity,
    IzzyChannelTypeActionEntity,
    IzzyChannelTypeExtensionEntity,
    IzzyCredentialExtensionEntity,
    IzzyCredentialTypeExtensionEntity,
    IzzyIssueTicketNumberEntity,
    IzzyIzzyActionCategoryEntity,
    IzzyIzzyActionEntity,
    IzzyIzzyActionOrganizationEntity,
    IzzyMacroEntity,
    IzzyOrganizationActionEntity,
    IzzyPendingCrawlResultEntity,
    IzzyPersonSkillEntity,
    IzzySLAPolicyEntity,
    IzzyScopeEntity,
    IzzySettingExtensionEntity,
    IzzySkillEntity,
    IzzySkillIssueTypeEntity,
    IzzyTicketMergeEntity,
    IzzyTicketNumberSequenceEntity,
    IzzyTicketSLAStateEntity,
    IzzyTicketSuggestionEntity,
    IzzyTicketTeamEntity,
    IzzyTicketTeamMemberEntity,
    OpenAILLMConverter,
    OrganizationActionEntityExtendedClient,
    OrganizationEntityExtended,
    OrganizationSettingEntityExtended,
    IzzyAdministrationResource,
    IzzyAnalyticsResource,
    IzzyApplication,
    IzzyMessageApprovalResource,
    IzzyMessagesContainerResource,
    IzzyTicketWorkspaceResource,
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CLASS_REGISTRATIONS: any[] = [
    ...CLASS_REGISTRATIONS_0,
];

/** Marker constant indicating the manifest has been loaded. */
export const CLASS_REGISTRATIONS_MANIFEST_LOADED = true;

/** Total @RegisterClass decorated classes discovered in dependency tree */
export const CLASS_REGISTRATIONS_COUNT = 45;

/** Packages imported by this manifest */
export const CLASS_REGISTRATIONS_PACKAGES = [
    'mj_generatedentities',
    'izzy-ui',
] as const;
